<template>
  <div class="q-edit-content">
    <span v-if="value.ext.edit">
      <div class="edit" v-for="(item, ind) in levels" :key="ind">
        <div class="area-title">{{ item.label }}</div>
        <vh-switch
          class="remove"
          @change="changeValue(item)"
          v-model="item.isRemove"
          active-color="#FB3A32"
          inactive-color="#CECECE"
          size="mini"
          v-if="item.value !== 'province'"
        >
        </vh-switch>
        <!-- <span class="remove" @click="areaRemove(item.isRemove)">{{item.isRemove}}</span> -->
      </div>
    </span>
    <div class="select" v-if="!isReplay">
      <div v-if="!value.ext.edit" class="q-edit-select vhall-inline">
        <vh-select
          v-model="provinceVal"
          @change="changeProvince"
          @focus="focusProvince"
          :placeholder="$t('form.form_1004')"
          size="small"
        >
          <vh-option
            v-for="(item, index) in provinces"
            :label="item.label"
            :value="item.value"
            :key="index"
          >
          </vh-option>
        </vh-select>
      </div>
      <div
        v-if="!value.ext.edit && showCity"
        class="q-edit-select vhall-inline"
      >
        <vh-select
          v-model="cityVal"
          @change="changeCity"
          @focus="focusCity"
          :placeholder="$t('form.form_1005')"
          size="small"
        >
          <vh-option
            v-for="(item, index) in cities"
            :label="item.label"
            :value="item.value"
            :key="index"
          >
          </vh-option>
        </vh-select>
      </div>
      <div
        v-if="!value.ext.edit && showCounty"
        class="q-edit-select vhall-inline"
      >
        <vh-select
          v-model="countyVal"
          @focus="focusCounty"
          :placeholder="$t('form.form_1006')"
          size="small"
        >
          <vh-option
            v-for="(item, index) in counties"
            :label="item.label"
            :value="item.value"
            :key="index"
          >
          </vh-option>
        </vh-select>
      </div>
    </div>
    <div
      v-if="!value.ext.edit && showAddress && !isReplay"
      class="q-edit-select"
    >
      <com-input
        :placeholder="$t('form.form_1042')"
        :disabled="value.ext.edit"
        v-model="value.address"
        @focus="focusAddress"
        :max-length="100"
      ></com-input>
    </div>
    <div v-if="isReplay" class="q-edit-select disabled">
      <com-input :disabled="true" v-model="address"></com-input>
    </div>
    <div v-if="!value.ext.edit && errorTip" class="error-msg">
      {{ errorTip }}
    </div>
  </div>
</template>

<script>
import questionService from "src/api/questionnaire-service";
import $ajax from "src/utils/ajax.js";
import ComInput from "../input/com.vue";

export default {
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
    isReplay: Boolean,
  },

  components: {
    "com-input": ComInput,
  },

  inject: ["sdk"],
  data() {
    return {
      provinceVal: "",
      cityVal: "",
      countyVal: "",
      levels: [
        {
          value: "province",
          label: this.$t("quest.k_3101"),
          isRemove: true,
        },
        {
          value: "city",
          label: this.$t("quest.k_3102"),
          isRemove: true,
        },
        {
          value: "county",
          label: this.$t("quest.k_3103"),
          isRemove: true,
        },
        {
          value: "address",
          label: this.$t("quest.k_3104"),
          isRemove: true,
        },
      ],
      area: {},
      province: "",
      city: "",
      county: "",
      provinces: [],
      cities: [],
      counties: [],
      errorTip: "",
      address: "",
    };
  },
  mounted() {
    if (this.isReplay) {
      //回显数据
      if (this.value.replayData) {
        this.address = this.value.replayData.replaceAll("|", "");
      }
    } else {
      this.sdk.getAreaData().then((res) => {
        this.area = res;
        this.provinces = this.area.provinces;
      });
      if (this.value.hasOwnProperty("detail"))
        this.initRemove(this.value.detail.level);
    }
  },
  computed: {
    showCity() {
      return (
        this.value.detail.level === "city" ||
        this.value.detail.level === "county" ||
        this.value.detail.level === "address"
      );
    },
    showCounty() {
      return (
        this.value.detail.level === "county" ||
        this.value.detail.level === "address"
      );
    },
    showAddress() {
      return this.value.detail.level === "address";
    },
  },
  methods: {
    changeProvince(value) {
      this.cities = this.area.cities[value];
      if (this.showCity) {
        this.cityVal = this.cities[0].value;
        this.counties = this.area.counties[this.cityVal];
        this.countyVal = "";
      }
    },
    changeCity(value) {
      if (this.showCounty) {
        this.counties =
          this.area.counties[value] || this.area.counties[this.cityVal];
        this.countyVal = this.counties[0].value;
      }
    },
    focusProvince() {
      this.errorTip = "";
    },
    focusCity() {
      this.errorTip = "";
    },
    focusCounty() {
      this.errorTip = "";
    },
    focusAddress() {
      this.errorTip = "";
    },
    check() {
      let value = [];
      if (this.value.required === "Y" && (!this.provinceVal || !this.cityVal)) {
        this.errorTip = this.$t("form.form_1083");
        return false;
      }
      if (this.provinceVal) {
        let txt = "";
        this.provinces.forEach((item) => {
          if (item.value === this.provinceVal) {
            value.push(item.label);
          }
        });
      }
      if (this.cityVal) {
        let txt = "";
        this.cities.forEach((item) => {
          if (item.value === this.cityVal) {
            value.push(item.label);
          }
        });
      }
      if (
        this.value.required === "Y" &&
        (this.value.detail.level === "county" ||
          this.value.detail.level === "address") &&
        !this.countyVal
      ) {
        this.errorTip = this.$t("form.form_1083");
        return false;
      }
      if (this.countyVal) {
        let txt = "";
        this.counties.forEach((item) => {
          if (item.value === this.countyVal) {
            value.push(item.label);
          }
        });
      }
      if (
        this.value.required === "Y" &&
        this.value.detail.level === "address" &&
        !this.value.address
      ) {
        this.errorTip = this.$t("form.form_1083");
        return false;
      }
      this.value.address && value.push(this.value.address);
      return {
        id: this.value.id,
        value: value.join("|"),
        style: this.value.style,
      };
    },
    changeValue(item) {
      if (item.value === "city" && !item.isRemove) {
        this.levels.forEach((items) => {
          items.isRemove = false;
        });
        this.value.detail.level = "province";
      }
      if (item.value === "city" && item.isRemove) {
        this.value.detail.level = "city";
      }
      if (item.value === "county") {
        this.levels.forEach((items) => {
          if (item.isRemove && items.value === "city") {
            items.isRemove = true;
            this.value.detail.level = "county";
          }
          if (!item.isRemove && items.value === "address") {
            items.isRemove = false;
            this.value.detail.level = "city";
          }
        });
      }
      if (item.value === "address") {
        if (item.isRemove) {
          this.levels.forEach((items) => {
            items.isRemove = true;
          });
          this.value.detail.level = "address";
        } else {
          this.value.detail.level = "county";
        }
      }
    },
    areaRemove(isRemove) {
      this.levels[1].isRemove = isRemove === "隐藏" ? "显示" : "隐藏";
      this.value.detail.level =
        this.levels[1].isRemove === "隐藏" ? "city" : "province";

      // if (isRemove==='隐藏') {
      //   this.levels.forEach((item, i) => {
      //     if (i >= ind) {
      //       this.levels[i].isRemove = '显示'
      //     }
      //   })
      // } else if (isRemove==='显示') {
      //   this.levels.forEach((item, i) => {
      //     if (i <= ind && i!==0) {
      //       this.levels[i].isRemove = '隐藏'
      //     }
      //   })
      // }

      // this.value.detail.level = this.levels[ind].value
    },
    initRemove(value) {
      if (value === "address") return;
      let i;
      this.levels.forEach((item, it) => {
        if (item.value === value) {
          i = it;
        }
      });
      this.levels.forEach((item, it) => {
        if (it <= i && it !== 0) {
          item.isRemove = true;
        } else if (it > i) {
          item.isRemove = false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
// 为了解决ios兼容性问题，下拉框选择时，需要点击两次才能选中
.vh-scrollbar .vh-scrollbar__bar {
  opacity: 1 !important;
  visibility: hidden;
}
.q-edit-content {
  /*margin-bottom: 30px;*/
  .q-edit-select {
    display: block;
    width: 100%;
    margin-bottom: 10px;
    .vh-select {
      width: 100%;
    }
    .com-input {
      width: 100%;
    }
    .remove {
      cursor: pointer;
      font-size: 12px;
      margin-left: 12px;
    }
    &.disabled {
      margin-top: 10px;
      color: #c2c2c2;
    }
  }

  &.display {
    margin-bottom: 0;
  }
  ::v-deep {
    .error-msg {
      position: absolute;
      color: #fc5659;
      padding-left: 10px;
      line-height: 20px;
      font-size: 12px;
    }
    .q-select-item {
    }
  }

  .vhall-inline {
    display: inline-block;
    margin-right: 12px;
    &:last-child {
      margin-right: 0;
    }
    // width: auto;
  }
  .edit {
    position: relative;
    .area-title {
      display: inline-block;
      margin-right: 50px;
      width: calc(100% - 50px);
      border: 1px solid #d2d2d2;
      background-color: #f2f2f2;
      height: 40px;
      padding: 0 10px;
      line-height: 40px;
      border-radius: 2px;
      margin-bottom: 14px;
      font-size: 14px;
      color: #999;
      cursor: not-allowed;
    }
    .remove {
      position: absolute;
      right: 6px;
      top: 7px;
      color: #999999;
      cursor: pointer;
      &:hover {
        color: #fc5659;
      }
    }
  }
}
</style>
